module.exports = __webpack_public_path__ + "static/lawadvisor-services-03-0955a01b9fd6ce7bb8bc642033bc8943.jpg";